export default __webpack_public_path__ + "static/media/boat.cfcc2814.png";